import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import DetailsViews from '../views/detail_views.vue'
import Login from '../views/LoginView.vue'
import store from '../store/index'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'LoginView',
    component: Login
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/details',
    name: 'DetailsViews',
    beforeEnter: (to, from, next) => {
      if (store.state.boxResultData === null) {
        next('/')
      } else {
        next()
      }
    },
    component: DetailsViews
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
